var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plSalesStatistic"},[_c('PlSalesStatisticGrid',{attrs:{"list":_vm.list}}),_c('plSalesStatisticTabs',{ref:"tabsRef",on:{"search":_vm.handleSearch,"export":_vm.handleExport}}),_c('PlSalesStatisticTable',{ref:"tableRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }